import { Shuffle } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const MixIcon = DeckardIconWrapper({ Icon: Shuffle });
